import React, { useMemo } from "react";
import { Button, Modal, Row, Typography, Col, Input, InputNumber, Table } from "antd";
import { AreaProps } from "src/entity/area/area.entity";
import { ObjectEmissionWithValue, ResponseManualWasteWater } from "src/entity/waste-water/manual-waste-water.entity";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { MONTHS_LISTS, MONTHS_LISTS_PASCAL } from "src/entity/common/time.constant";
import { TmpReportEmissionData } from "src/entity/waste-water/report-voc-emission.entity";
import { ReportStatusEnum } from "src/entity/voc-approve/voc-approve.entity";
import { formatNumber } from "src/utils/process-number";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { convertEmissionWord } from "src/entity/common/global.entity";
import { OthersEmission } from "src/entity/others/information";
import { FillEmissionObject, ResponseOthersFillEmission } from "src/entity/others/fill-emission";
import { capitalizeFirstLetter } from "src/utils/manage-string";
import { UnitAllEnum } from "src/entity/common/unit.constant";
import "./FillEmissionModal.css";

const { Text } = Typography;
interface RecordProps {
  key: number;
  type: keyof ResponseOthersFillEmission;
}
interface FillEmissionModalProps {
  submitFillEmission: () => void;
  loadingManageFillEmission: boolean;
  visibleModal: boolean;
  closeModal: () => void;
  errorFillEmission: string | null;
  isEdit: ResponseOthersFillEmission | null;
  getMasterLabel: (type: string, text: string) => string | undefined;
  onUpdateKeyValue: (key: keyof OthersEmission, value: string | number, month: string) => void;
}

const FillEmissionModal: React.FC<FillEmissionModalProps> = (props) => {
  const {
    submitFillEmission,
    loadingManageFillEmission,
    closeModal,
    visibleModal,
    errorFillEmission,
    isEdit,
    getMasterLabel,
    onUpdateKeyValue,
  } = props;

  // console.log("[Manual] IS EIDT :: ", isEdit);

  const activeEmissionLists = useMemo(() => {
    const lists: any = [];
    if (!isEdit?.cloneEmission) return lists;
    for (const key in isEdit?.cloneEmission) {
      if (isEdit.cloneEmission[key as keyof ObjectEmissionWithValue].active) lists.push(key);
    }
    return lists;
  }, [isEdit]);

  const isSomeProcessing = useMemo(() => {
    if (!isEdit) return true;

    let someMonthProcessing = false;
    const months = MONTHS_LISTS;
    const activeEmissions: string[] = activeEmissionLists.filter((item: string) => item != "header_column");

    for (const key in isEdit?.vocEmission) {
      if (activeEmissions.includes(key)) {
        for (const month of months) {
          if (
            isEdit.vocEmission[key as keyof ObjectEmissionWithValue][month as keyof TmpReportEmissionData].reportStatus ===
            ReportStatusEnum.PROCESSING
          ) {
            someMonthProcessing = true;
            break;
          }
        }
        break;
      }
    }
    return someMonthProcessing;
  }, [isEdit]);

  const getColumns = () => {
    return MONTHS_LISTS.map((month) => ({
      title: capitalizeFirstLetter(month),
      key: month,
      align: "center" as const,
      render: (_: any, record: RecordProps) => (
        <InputNumber
          onChange={(val) => onUpdateKeyValue(record.type as keyof ObjectEmissionWithValue, val?.toString() as string | number, month)}
          className="w-16"
          value={isEdit?.cloneEmission[record.type as keyof ObjectEmissionWithValue].fillEmission[month as keyof FillEmissionObject]}
          //   disabled={
          //     isEdit?.manualFlareVolume &&
          //     isEdit?.manualFlareVolume[record.type][item as keyof KeyofMonthly].reportStatus !== ReportStatusEnum.PROCESSING
          //   }
          onKeyDown={(e) => {
            onKeyDownNumberWithFixedDecimal(e, 2);
          }}
          formatter={(value) => formatNumber(value as number, 2)}
        />
      ),
    }));
  };

  // console.log("activeEmissionLists :: ", activeEmissionLists);

  const sourceData = useMemo(() => {
    if (!activeEmissionLists) return [];
    return activeEmissionLists.map((item: string, index: number) => ({
      key: index + 1,
      type: item,
    }));
  }, [activeEmissionLists]);

  return (
    <Modal
      title={<ModalTitle title="Fill Emission" />}
      open={visibleModal}
      width={1000}
      onCancel={closeModal}
      footer={
        <Row className="w-full border-t" justify={"end"}>
          <Button className="mt-4" key="submit" type="primary" loading={loadingManageFillEmission} onClick={submitFillEmission}>
            Save
          </Button>
        </Row>
      }
      maskClosable={false}
      centered
    >
      {errorFillEmission && (
        <Row className="w-full" justify={"center"}>
          <Text type="danger">{errorFillEmission}</Text>
        </Row>
      )}
      <Row className="w-full mt-4" gutter={[12, 0]} justify={"center"}>
        <Col xs={12} sm={6} md={6}>
          <Text>Source Name</Text>
          <Input className="mt-2" disabled value={isEdit?.sourceName} />
        </Col>
        <Col xs={12} sm={6} md={6}>
          <Text>Area</Text>
          <Input className="mt-2" disabled value={getMasterLabel("area", isEdit?.area as string)} />
        </Col>
      </Row>

      <br></br>

      <Table
        id="wrap-manual-fill-emission-table-config"
        columns={[
          {
            title: "",
            dataIndex: "type",
            key: "type",
            render: (text) => <Text>{convertEmissionWord(text.toUpperCase())}</Text>,
          },
          {
            title: "Unit",
            key: "unit",
            render: () => <Text>{UnitAllEnum.KG}</Text>,
          },
          ...getColumns(),
        ]}
        scroll={{ x: "max-content" }}
        size={"small"}
        dataSource={sourceData}
        pagination={false}
      />
    </Modal>
  );
};

export default FillEmissionModal;
